<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="220.000000pt"
    height="220.000000pt"
    viewBox="0 0 220.000000 220.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,220.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M746 2134 c-11 -10 -16 -34 -16 -70 l0 -54 -88 0 c-75 0 -92 -3 -106
-19 -14 -15 -34 -20 -101 -23 -51 -2 -89 -8 -97 -16 -10 -10 -13 -194 -13
-948 0 -915 0 -936 19 -950 17 -12 133 -14 731 -14 627 0 713 2 733 16 l22 15
0 934 0 934 -22 15 c-16 12 -47 16 -112 16 -73 0 -91 3 -102 18 -9 13 -32 18
-101 22 l-88 5 -3 55 c-2 37 -8 59 -19 68 -13 9 -93 12 -319 12 -262 0 -305
-2 -318 -16z m240 -70 c-21 -22 -26 -36 -26 -76 0 -41 5 -54 29 -79 24 -24 38
-29 76 -29 38 0 52 5 76 29 40 40 41 105 3 151 l-26 31 113 -3 114 -3 3 -67 3
-67 97 -3 97 -3 0 -60 0 -60 -483 -3 -483 -2 3 62 3 63 95 3 c60 2 97 7 102
15 4 7 8 38 8 70 l0 57 111 0 112 0 -27 -26z m112 -46 c29 -29 -7 -86 -47 -73
-26 8 -38 50 -21 70 15 18 51 20 68 3z m-580 -168 c6 -97 -37 -90 548 -90
l513 0 15 22 c10 14 16 44 16 76 l0 53 78 -3 77 -3 0 -900 0 -900 -690 0 -690
0 -3 890 c-1 490 0 896 3 903 3 9 23 12 67 10 l63 -3 3 -55z"
      />
      <path
        d="M1241 1613 c-93 -46 -117 -187 -46 -283 20 -28 25 -45 25 -96 0 -99
18 -164 55 -201 37 -37 63 -41 96 -14 20 16 23 30 29 112 10 158 35 157 47 -2
7 -108 24 -135 76 -125 16 3 36 11 43 17 29 24 48 87 54 179 6 84 10 101 39
147 31 48 33 57 29 117 -4 70 -21 102 -72 140 -25 19 -43 21 -184 23 -128 2
-163 -1 -191 -14z m150 -60 c27 -16 31 -16 58 0 16 9 46 17 66 17 30 0 45 -8
76 -39 49 -49 51 -85 8 -153 -28 -43 -32 -60 -39 -153 -6 -76 -13 -112 -26
-132 l-19 -28 -8 95 c-9 120 -25 145 -88 145 -40 0 -45 -3 -61 -35 -13 -24
-18 -59 -18 -112 0 -42 -4 -79 -9 -82 -19 -12 -44 69 -48 158 -5 80 -9 97 -36
140 -36 57 -39 105 -9 145 38 51 100 65 153 34z"
      />
      <path
        d="M617 1584 c-4 -4 -7 -24 -7 -45 0 -37 -1 -38 -42 -41 l-43 -3 0 -115
0 -115 43 -3 c42 -3 42 -3 42 -42 0 -49 10 -52 135 -48 l90 3 3 42 c3 42 3 42
45 45 l42 3 3 118 3 117 -45 0 -45 0 -3 43 -3 42 -106 3 c-58 1 -108 -1 -112
-4z m165 -96 c3 -43 3 -43 46 -46 l42 -3 0 -59 0 -59 -42 -3 c-42 -3 -43 -4
-46 -40 l-3 -38 -55 0 -54 0 0 40 0 40 -45 0 -45 0 0 60 0 60 45 0 45 0 0 45
0 45 54 0 55 0 3 -42z"
      />
      <path d="M512 1053 l3 -28 250 0 250 0 3 28 3 27 -256 0 -256 0 3 -27z" />
      <path
        d="M517 803 c-4 -3 -7 -17 -7 -30 l0 -23 536 0 535 0 -3 28 -3 27 -526
3 c-289 1 -529 -1 -532 -5z"
      />
      <path
        d="M517 563 c-4 -3 -7 -17 -7 -30 l0 -23 536 0 535 0 -3 28 -3 27 -526
3 c-289 1 -529 -1 -532 -5z"
      />
      <path d="M510 300 l0 -30 533 2 532 3 3 28 3 27 -535 0 -536 0 0 -30z" />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
